// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".TruncateHeight-cls1__a3ef8d4f04ca8375d957{/*!*/}.TruncateHeight-cls2___fa8e98574a63c55d0d9{display:block}.TruncateHeight-cls2___fa8e98574a63c55d0d9::before{content:\"...\";padding-right:.2em;padding-left:1em;text-decoration:none;display:inline-block}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "TruncateHeight-cls1__a3ef8d4f04ca8375d957",
	"cls2": "TruncateHeight-cls2___fa8e98574a63c55d0d9 TruncateHeight-cls1__a3ef8d4f04ca8375d957"
};
export default ___CSS_LOADER_EXPORT___;
